"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _default = function _default(_ref) {
  var entities = _ref.entities;

  // eslint-disable-next-line no-unused-vars
  var EntityList = function (_ref3) {
    var children = _ref3.children,
        entityList = _ref3.entityList,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["children", "entityList"]);
    return children(entityList);
  };

  EntityList.propTypes = {
    children: _propTypes.default.func,
    entityIds: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,
    entityType: _propTypes.default.string.isRequired,
    entityList: _propTypes.default.arrayOf(_propTypes.default.object)
  };
  return (0, _reactRedux.connect)(function mapStateToProps(state, _ref2) {
    var entityIds = _ref2.entityIds,
        entityType = _ref2.entityType;
    return {
      entityList: entities.selectors.getList(state, entityType, entityIds)
    };
  })(EntityList);
};

exports.default = _default;